import { Component, Input } from '@angular/core';
import { WorkEquipmentlog } from '../../_generated/work-rest-api';

@Component({
  selector: 'ax-office-betriebsmittel-aktueller-ort',
  templateUrl: './betriebsmittel-aktueller-ort.component.html',
  styleUrls: ['./betriebsmittel-aktueller-ort.component.scss'],
})
export class BetriebsmittelAktuellerOrtComponent {
  @Input() equipmentlog: WorkEquipmentlog | undefined;
  @Input() renderTextOnly = false;
  @Input() withBadge = true;
  public hasReadPermission = true;
}
